module.exports = __webpack_public_path__ + "static/img/yczgzp.7a1ff653.png";